module.exports = __webpack_public_path__ + "static/media/24-7.a5dce2a7.png";